import { Injectable } from "@angular/core";
import { MessageService } from "primeng/api";

/**
 * this service class is provide the commonly utilized methods
 * @author chari on 05/26/2025
 */

export enum Severity {
    error = 'error',
    success = 'success',
    warn = 'warn',
    info = 'info'
}

@Injectable({
    providedIn: 'root'
})


export class CommonMethods {

    constructor(private _messageService: MessageService) { }

    /**
     * This method is used to celar the current showing toast message
     * @author chari on 05/26/2025
     */
    clearToast() {
        this._messageService.clear('genericToastKey');
    }

    /**
     * This method is used to display the toast message in the application
     * @param errorMsg  message string
     * @param errorTitle title string
     * @param severity  toast type info,success,error,warn
     * @returns 
     * @author chari on 05/26/2025
     */
    showToastMessage(errorMsg: string, errorTitle: string, severity: Severity, autoClear: boolean = true, styleClass: string = '') {
        this.clearToast();
        if (autoClear) {
            setTimeout(() => {
                this.clearToast();
            }, 6000);
        }
        if (severity === Severity.error) {
            return this._messageService.add({
                severity: 'error',
                key: 'genericToastKey',
                sticky: true,
                //summary: errorTitle,
                detail: errorMsg,
                styleClass: styleClass
            });
        } else if (severity === Severity.success) {
            return this._messageService.add({
                severity: 'success',
                key: 'genericToastKey',
                sticky: true,
                //summary: errorTitle,
                detail: errorMsg,
                styleClass: styleClass
            });
        } else if (severity === Severity.warn) {
            return this._messageService.add({
                severity: 'warn',
                key: 'genericToastKey',
                sticky: true,
                //summary: errorTitle,
                detail: errorMsg,
                styleClass: styleClass
            });
        } else if (severity === Severity.info) {
            return this._messageService.add({
                severity: 'info',
                key: 'genericToastKey',
                sticky: true,
                //summary: errorTitle,
                detail: errorMsg,
                styleClass: styleClass
            });
        }
    }

    /**
     * Checks if a value is empty. A value is considered empty unless it's an object with at least one enumerable property.
     * @param value The value to check
     * @returns {boolean} Returns true if value is empty, else false
     * @author chari on 05/26/2025
     */
    public isEmpty(value: any): boolean {
        if (value === null || value === undefined) {
            return true;
        }

        if (typeof value === 'object') {
            if (Array.isArray(value)) {
                return value.length === 0;
            }
            return Object.keys(value).length === 0;
        }

        if (typeof value === 'string') {
            return value.trim().length === 0;
        }

        if (typeof value === 'number') {
            return false;
        }

        return true;
    }

}
